export default "__VITE_ASSET__BMvgOAu4__"